/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailFailureReason } from './EmailFailureReason';
import {
    EmailFailureReasonFromJSON,
    EmailFailureReasonFromJSONTyped,
    EmailFailureReasonToJSON,
} from './EmailFailureReason';

/**
 * What became of the buyer-facing email an action dispatched.
 * 
 * The action itself still succeeded — the status change is correct — so a
 * blocked send is reported here rather than raised. Present only on the
 * responses of the actions that dispatch one (reject, counter), and only when
 * a send was actually attempted: an email suppressed by the rejection reason,
 * or deferred to a counter's document upload, leaves this null.
 * @export
 * @interface TransactionEmailOutcomeResponse
 */
export interface TransactionEmailOutcomeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TransactionEmailOutcomeResponse
     */
    sent: boolean;
    /**
     * 
     * @type {EmailFailureReason}
     * @memberof TransactionEmailOutcomeResponse
     */
    reason?: EmailFailureReason;
    /**
     * 
     * @type {string}
     * @memberof TransactionEmailOutcomeResponse
     */
    lcepAgentName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEmailOutcomeResponse
     */
    lcepState?: string;
}

/**
 * Check if a given object implements the TransactionEmailOutcomeResponse interface.
 */
export function instanceOfTransactionEmailOutcomeResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sent" in value;

    return isInstance;
}

export function TransactionEmailOutcomeResponseFromJSON(json: any): TransactionEmailOutcomeResponse {
    return TransactionEmailOutcomeResponseFromJSONTyped(json, false);
}

export function TransactionEmailOutcomeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionEmailOutcomeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sent': json['sent'],
        'reason': !exists(json, 'reason') ? undefined : EmailFailureReasonFromJSON(json['reason']),
        'lcepAgentName': !exists(json, 'lcep_agent_name') ? undefined : json['lcep_agent_name'],
        'lcepState': !exists(json, 'lcep_state') ? undefined : json['lcep_state'],
    };
}

export function TransactionEmailOutcomeResponseToJSON(value?: TransactionEmailOutcomeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sent': value.sent,
        'reason': EmailFailureReasonToJSON(value.reason),
        'lcep_agent_name': value.lcepAgentName,
        'lcep_state': value.lcepState,
    };
}

